import { render, staticRenderFns } from "./UsuarioActive.vue?vue&type=template&id=67523542"
import script from "./UsuarioActive.vue?vue&type=script&lang=js"
export * from "./UsuarioActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67523542')) {
      api.createRecord('67523542', component.options)
    } else {
      api.reload('67523542', component.options)
    }
    module.hot.accept("./UsuarioActive.vue?vue&type=template&id=67523542", function () {
      api.rerender('67523542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/UsuarioActive.vue"
export default component.exports